export enum DisplayConditionStoreEnum {
  NextStep = 'next_step',
  HideFromCustomer = 'hide_from_customer',
}

export type NextStepDisplayConditionConfigType = {
  name: DisplayConditionStoreEnum.NextStep
  payload: {
    storeField: 'next_step'
    displayWhenProjectRecorded: boolean
  }
}

export type HideFromCustomerDisplayConditionConfigType = {
  name: DisplayConditionStoreEnum.HideFromCustomer
  payload: {
    show: boolean
  }
}

export type DisplayConditionType = NextStepDisplayConditionConfigType | HideFromCustomerDisplayConditionConfigType
